import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { ListaDistribuzioneAnagrafeDTO } from "@app/shared/dto/anagrafe/lista-distribuzione-anagrafeDTO";
import { ListaDistribuzioneAnagrafeVO } from "@app/shared/vo/gescor/lista-distribuzione-anagrafeVO";

@Injectable({
    providedIn: "root"
  })
export class MapperListaDistribuzioneAnagrafe
  implements
    MapperInterface<
      ListaDistribuzioneAnagrafeDTO,
      ListaDistribuzioneAnagrafeVO
    > {
  convertVoToDto(
    listaDistribuzioneAnagrafeVO: ListaDistribuzioneAnagrafeVO
  ): ListaDistribuzioneAnagrafeDTO {
    throw new Error("Method not implemented.");
  }

  convertDtoToVo(
    listaDistribuzioneAnagrafeDTO: ListaDistribuzioneAnagrafeDTO
  ): ListaDistribuzioneAnagrafeVO {
    console.log("MapperListaDistribuzioneAnagrafe convertDtoToVo");
    const listaDistribuzioneAnagrafeVO = new ListaDistribuzioneAnagrafeVO();
    listaDistribuzioneAnagrafeVO.descrizione =
      listaDistribuzioneAnagrafeDTO.descrizione;
    listaDistribuzioneAnagrafeVO.id = listaDistribuzioneAnagrafeDTO.id;
    listaDistribuzioneAnagrafeVO.nome = listaDistribuzioneAnagrafeDTO.nome;
    listaDistribuzioneAnagrafeVO.recapiti = new Array<string>();
    listaDistribuzioneAnagrafeVO.recapiti =
      listaDistribuzioneAnagrafeDTO.recapiti;
    listaDistribuzioneAnagrafeVO.settore =
      listaDistribuzioneAnagrafeDTO.settore;
    return listaDistribuzioneAnagrafeVO || new ListaDistribuzioneAnagrafeVO();
  }

  convertListVoToDto(
    listaDistribuzioneAnagrafeVOList: ListaDistribuzioneAnagrafeVO[]
  ): ListaDistribuzioneAnagrafeDTO[] {
    throw new Error("Method not implemented.");
  }

  convertListDtoToVo(
    listaDistribuzioneAnagrafeDTOList: ListaDistribuzioneAnagrafeDTO[]
  ): ListaDistribuzioneAnagrafeVO[] {
    console.log("MapperListaDistribuzioneAnagrafe convertListDtoToVo");
    const listaDistribuzioneAnagrafeVO = new Array<
      ListaDistribuzioneAnagrafeVO
    >();
    listaDistribuzioneAnagrafeDTOList.forEach(listaDistribuzioneAnagrafeDTO => {
      listaDistribuzioneAnagrafeVO.push(
        this.convertDtoToVo(listaDistribuzioneAnagrafeDTO)
      );
    });
    return (
      listaDistribuzioneAnagrafeVO || new Array<ListaDistribuzioneAnagrafeVO>()
    );
  }
}
